<template>
  <div class="footer">
    <div class="container-fluid">
      <nav class="pull-left w-100" aria-label="Main">
        <p class="link"> {{ text }} </p>
      </nav>
    </div>
  </div>
</template>

<script>
  import {TranslationsUtils} from '../../../utils/Translations'
  export default {
    mixins: [TranslationsUtils],
    data () {
      return {}
    },
    computed: {
      text () {
        return this.computeCaption(this.$store.state.configs.PATIENT_SUPPORT_INFO, this.$store.state.lang.value.toLowerCase())
      }
    }
  }

</script>
<style scoped>
.footer {
  position: relative !important;
}
.footer nav {
    min-height: 75px;
}
.w-100{
  width: 100%;
}

.link{
  line-height: 2.9;
  float: left;
}

@media only screen and (max-width: 760px) {
  .link { 
    line-height: 1;
  }

  .footer nav {
    min-height: 0;
  }

  p {
    font-size: 13px;
    margin: 5px 0 0;
  }

  .footer {
    padding-bottom: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue